import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../../component/shared/shared.service';
@Component({
  selector: 'app-medical-history',
  templateUrl: './medical-history.component.html',
  styleUrls: ['./medical-history.component.css']
})
export class MedicalHistoryComponent implements OnInit {

  constructor(private _sharedService: SharedService) { }

  ngOnInit() {
  }
 ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/section/report/medical-history/medical-history.component.ts